import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlackHole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlackHole"><Path fillRule="evenodd" clipRule="evenodd" d="M5.81004 19.2066L2.5 21.8073V11.9998C2.5 6.75314 6.75329 2.49985 12 2.49985C14.3643 2.49985 16.528 3.36455 18.19 4.79313L21.5 2.19238V11.9998C21.5 17.2466 17.2467 21.4998 12 21.4998C9.63569 21.4998 7.47203 20.6351 5.81004 19.2066ZM12 15.4998C13.933 15.4998 15.5 13.9328 15.5 11.9998C15.5 10.0668 13.933 8.49976 12 8.49976C10.067 8.49976 8.5 10.0668 8.5 11.9998C8.5 13.9328 10.067 15.4998 12 15.4998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlackHole;
